import { colorsPalette, styled } from '@lingoda/ui/theme';
import { Divider as UiDivider } from '@lingoda/ui';

export const Divider = styled(UiDivider)(({ theme }) => ({
    '&&&': {
        margin: theme.spacing(2, 0),
        backgroundColor: colorsPalette.blackAlpha[8],
        borderColor: 'transparent',
    },
}));
